/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ms_Set_Target_ShortInputs */

const en_ms_set_target_short = /** @type {(inputs: Ms_Set_Target_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set target date`)
};

const de_ms_set_target_short = /** @type {(inputs: Ms_Set_Target_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zieldatum setzen`)
};

/**
* | output |
* | --- |
* | "Set target date" |
*
* @param {Ms_Set_Target_ShortInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ms_set_target_short = /** @type {((inputs?: Ms_Set_Target_ShortInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ms_Set_Target_ShortInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ms_set_target_short(inputs)
	return en_ms_set_target_short(inputs)
});